import { render, staticRenderFns } from "./ViewFormerMembers.vue?vue&type=template&id=36ff73f0&scoped=true"
import script from "./ViewFormerMembers.vue?vue&type=script&lang=js"
export * from "./ViewFormerMembers.vue?vue&type=script&lang=js"
import style0 from "./ViewFormerMembers.vue?vue&type=style&index=0&id=36ff73f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff73f0",
  null
  
)

export default component.exports